/**
 * Scan qui n'est manifestement pas un code-barres produit : QR code d'une adresse web, texte.
 * Seuls les cas évidents sont écartés ; un code interne alphanumérique reste un code.
 *  - commence par http(s):// ou www., ou contient « :// » ;
 *  - contient un espace, ou plus de 40 caractères ;
 *  - minuscules avec « . », « / », « ? », « = » ou « & » (forme d'adresse ou de paramètres).
 */
export const MAX_PRODUCT_CODE_LENGTH = 40;

export const isObviousNonProductScan = (code: string): boolean => {
  const value = code.trim();
  if (/^(https?:\/\/|www\.)/i.test(value) || value.includes('://')) return true;
  if (/\s/.test(value) || value.length > MAX_PRODUCT_CODE_LENGTH) return true;
  return /[a-z]/.test(value) && /[./?=&]/.test(value);
};
